__turbopack_context__.v({
  "clamp": "BlogCard-module-scss-module__g0nEEW__clamp",
});
